module.exports = __webpack_public_path__ + "img/lady-beetle.d6dfaf58.png";